import React, { useState } from 'react';

// Sample theme data (replace with your actual theme)
const COLORS = {
  primary: '#8e44ad',
  primaryLight: '#d2b4de',
  white: '#ffffff',
  dark: '#333333',
  gray: '#808080',
  lightGray: '#f3e5f5',
};

const FONTS = {
  h5: { fontSize: '1.25rem', fontWeight: 'bold' },
};

const ScheduleScreen = ({ navigation, data = {} }) => {
  const [selectedSchedule, setSelectedSchedule] = useState('academic');

  const setScheduleDataHandler = (type) => {
    setSelectedSchedule(type);
  };

  const openWebViewScreen = (url) => {
    window.open(url, '_blank');
  };

  const selectedData =
    selectedSchedule === 'academic'
      ? data?.academic || []
      : selectedSchedule === 'practice'
      ? data?.practice || []
      : data?.general || [];

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        flex: 1,
        padding: '12px',
        marginTop: '20px',
        backgroundColor: COLORS.primaryLight,
        borderRadius: '8px',
      }}
    >
      <h2
        style={{
          fontSize: '18px',
          fontWeight: 'bold',
          color: COLORS.dark,
          marginBottom: '12px',
        }}
      >
        YoungMinds Varsity
      </h2>

      {/* Tabs */}
      <div style={{ display: 'flex', flexDirection: 'row', marginBottom: '12px' }}>
        {['academic', 'practice', 'general'].map((type) => (
          <button
            key={type}
            onClick={() => setScheduleDataHandler(type)}
            style={{
              flex: 1,
              padding: '12px 0',
              margin: '0 2px',
              backgroundColor: selectedSchedule === type ? COLORS.primary : COLORS.primaryLight,
              color: selectedSchedule === type ? COLORS.white : COLORS.dark,
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer',
            }}
          >
            {type.charAt(0).toUpperCase() + type.slice(1)}
          </button>
        ))}
      </div>

      {/* List of Items */}
      {selectedData.length > 0 ? (
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          {selectedData.map((item) => (
            <div key={item.id} style={{ padding: '4px' }}>
              <div
                onClick={() => openWebViewScreen(item.link)}
                style={{
                  padding: '12px',
                  margin: '4px 0',
                  borderRadius: '8px',
                  border: '1px solid #ccc',
                  cursor: 'pointer',
                }}
              >
                <p style={{ color: COLORS.dark, fontWeight: 'bold', margin: 0 }}>
                  {item.title}
                </p>
                <p style={{ color: COLORS.dark, fontSize: '12px', marginTop: '4px' }}>
                  Date: {new Date().toLocaleDateString('en-GB')}
                </p>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <p style={{ textAlign: 'center', color: COLORS.dark }}>No Schedule found...</p>
      )}
    </div>
  );
};

export default ScheduleScreen;
